import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {CheckmarkIcon} from '../../icons/checkmark-icon';
import {WarningIcon} from '../../';

const getBackgroundColor = (percent, threshold, theme) => {
	if (+percent.toFixed(2) > +threshold.toFixed(2)) {
		switch (theme) {
			case 'LIGHT':
				return '#FFE3E2';
			case 'DARK':
				return '#FFC2C0';
		}
	} else {
		switch (theme) {
			case 'LIGHT':
				return '#EEFAF3';
			case 'DARK':
				return '#BFEDD3';
		}
	}
};
const Container = Styled.div`
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const Meter = Styled.div`
	
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: ${({percent}) => `${percent <= 1 ? 100 - percent * 100 : 0}%`};
    background: ${({percent, threshold, theme}) => getBackgroundColor(percent, threshold, theme)};
`;

const PercentageText = Styled.p`
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 12px;
    z-index: 1;
`;
const Theme = {
	LIGHT: 'LIGHT',
	DARK: 'DARK',
};

export const UtilizationMeter = ({
	percentage = 0,
	theme = 'LIGHT',
	content,
	checkmarkValue = 1,
	redThreshold = 1,
	warningThreshold = 2,
}) => {
	if (!content) {
		if (percentage > warningThreshold) {
			content = <WarningIcon updated />;
		} else if (percentage.toFixed(2) === checkmarkValue.toFixed(2)) {
			content = <CheckmarkIcon />;
		} else {
			content = <PercentageText>{`${(percentage * 100).toFixed(0)}%`}</PercentageText>;
		}
	}

	return (
		<Container>
			<Meter theme={theme} percent={percentage} threshold={redThreshold} />
			<div style={{zIndex: '1'}}>{content}</div>
		</Container>
	);
};

UtilizationMeter.propTypes = {
	percentage: PropTypes.number,
	theme: PropTypes.oneOf(Object.values(Theme)),
	redThreshold: PropTypes.number,
	warningThreshold: PropTypes.number,
	checkmarkValue: PropTypes.number,
	/**
	 * Optional content on top of the meter. If nothing is provided it comes with a default set.
	 */
	content: PropTypes.node,
};
